import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { fetchStates } from "src/store/slices/statesSlice";

const useStates = () => {
  const dispatch = useAppDispatch();
  const { items, loading, error, loaded} = useAppSelector((state) => state.states)

  useEffect(() => {
    if (!loaded && !loading && !error) {
      dispatch(fetchStates());
    }
  }, [dispatch, loaded, loading, error])

  return {states: items, loading, error, loaded}
}

export default useStates;